import { createSlice } from '@reduxjs/toolkit';

const initialState: {
  isDegraded: boolean;
} = {
  isDegraded: false,
};

export const performanceSlice = createSlice({
  name: 'performance',
  initialState,
  reducers: {
    degrade: (state) => {
      state.isDegraded = true;
    },
  },
});

export const performanceActions = performanceSlice.actions;
